import React from 'react';
import { MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';

const WhatsAppButton = () => {
  const handleClick = () => {
    window.open(`https://wa.me/${contactInfo.whatsapp}`, '_blank');
  };

  return (
    <button 
      className="whatsapp-float"
      onClick={handleClick}
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle size={28} />
    </button>
  );
};

export default WhatsAppButton;